import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material';
import { AppService } from 'src/app/_service/app.service';
//import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {
emailRequest:any = {
  RequestFrom:"",
  RequesterName:"",
  RequestTo:"",
  Subject:"",
  Message:"",
  Attachment:""
};
user:any = {
UserId:"",
UserName:"",
CompanyId:""
}

  constructor(public dialog: MatDialog, private appService: AppService,
        private router: Router,private route: ActivatedRoute,
      private locationn: Location) { 
        const data = JSON.parse(localStorage.getItem('office_q_uid'));
        this.user.UserId = data.UserId;
        this.user.UserName = data.UserName;
        this.user.CompanyId = data.CompanyId;
        this.emailRequest.RequesterName = data.UserName;
        this.emailRequest.Subject = "User Delete Request";
      }

  ngOnInit() {
    this.getAdminUserMailId();
  }

  getAdminUserMailId(){
    this.appService.postService({...this.user}, 'GetAdminUserEmailId')
    .subscribe(response => {
      if (response.body.Success){
        this.emailRequest.RequestTo = response.body.Result.user.EmailId;
      }
    });
  }
  sendUserDeleteRequest(){
    this.emailRequest.Message = "<p>Dear Admin,</p><p/><p>You have received an information from user regarding the delete request/support request.</p><p/><p>Email: " + this.emailRequest.RequestFrom + "</p><p>Message:Please delete my account.</p>"
    this.appService.postService({...this.emailRequest}, 'SendUserDeleteRequest')
    .subscribe(response => {
      if (response.body.Success){
        this.router.navigate(['/app/dashboard']);
      }
    });
  }
  
  goBack(): void{
    this.locationn.back();
  }
}